export default "__VITE_ASSET__BZfB_PsV__"